var baseStyle = () => {
  return {
    root: {
      '.react-datepicker': {
        borderRadius: '4px'
      },
      '.react-datepicker__day--selected': {
        background: '#0D1F63',
        color: '#fff'
      },
      '.react-datepicker__day--in-range': {
        // Hacky important because of a quirk with react-datepicker
        background: '#EBF7FF !important',
        color: '#000'
      },
      '.react-datepicker__day--disabled': {
        color: '#C4C4C4',
        borderColor: '#FFFFFF'
      },
      '.react-datepicker__day--range-start,.react-datepicker__day--range-end': {
        // Hacky important because of a quirk with react-datepicker
        background: '#0D1F63 !important',
        color: '#fff !important'
      },
      '.react-datepicker__day--in-selecting-range': {
        background: 'none',
        color: '#000'
      },
      '.react-datepicker__day': {
        borderRadius: '4px',
        _focus: {
          outline: 'none',
          boxShadow: '0px 0px 3px 2px #2182EB'
        },
        _hover: {
          borderColor: 'blue.1140',
          background: 'blue.1140',
          borderWidth: '1px',
          color: '#000'
        }
      },
      '.tqc-select__option--is-focused': {
        background: '#EBF7FF !important'
      },
      '.tqc-date-picker__nav-button[disabled=true]': {
        color: '#6D6D6D !important'
      }
    }
  };
};
export var DatePicker = {
  baseStyle
};